import { useState, useCallback } from "react";
import {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from "../API/endpoint";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadCategories = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getCategories();
      setCategories(data);
      setError("");
    } catch (err) {
      setError("Erreur lors du chargement des catégories");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCreateCategory = useCallback(async (categoryData) => {
    try {
      await createCategory(categoryData);
      await loadCategories();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la création de la catégorie");
      console.error(err);
      return false;
    }
  }, [loadCategories]);

  const handleUpdateCategory = useCallback(async (id, categoryData) => {
    try {
      await updateCategory(id, categoryData);
      await loadCategories();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la mise à jour de la catégorie");
      console.error(err);
      return false;
    }
  }, [loadCategories]);

  const handleDeleteCategory = useCallback(async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette catégorie ?")) {
      try {
        await deleteCategory(id);
        await loadCategories();
        setError("");
        return true;
      } catch (err) {
        setError("Erreur lors de la suppression (peut-être des produits liés ?)");
        console.error(err);
        return false;
      }
    }
    return false;
  }, [loadCategories]);

  return {
    categories,
    loading,
    error,
    setError,
    loadCategories,
    handleCreateCategory,
    handleUpdateCategory,
    handleDeleteCategory,
  };
};
